module.exports = __webpack_public_path__ + "static/media/videoHome1.1196ca10.mp4";